import Auth from "j-toker";
import $ from "jquery";
import iNoBounce from "inobounce";
export default {
  // production
  baseUrl: "https://app.yaystack.co/",
  baseAPI: "https://app.yaystack.co/api/v1/",

  websiteURL: "https://app.yaystack.co/",

  // Make sure jToker has the proper callbacks configured
  reconfigureAuth: function() {
    // update auth creds after each request to the API
    $(document).ajaxComplete(Auth.updateAuthCredentials);

    // intercept requests to the API, append auth headers
    $.ajaxSetup({ beforeSend: Auth.appendAuthHeaders });
  },

  // turn the bounce on or off based on the user agent
  setNoBounce: function() {
    iNoBounce.enable();
  }
};



// WEBPACK FOOTER //
// ./src/globals.jsx